"use client";
import React from "react";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { languages } from "@/app/i18n/settings";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
import { ChevronLeftCircle, ChevronRightCircle } from "lucide-react";
interface Props {
    currentPage: number;
    totalPage: number;
}
const ArticleListControl = dynamic(() => import("./article-list-control"), { ssr: false, loading: () => <LoadingComponent /> });

const LoadingComponent = () => {
    const pathName = usePathname();
    const lng = languages.find((l) => pathName.startsWith(`/${l}`)) ?? "th";
    let title = lng === "en" ? "Page" : "หน้าที่";
    let from = lng === "en" ? "from" : "จาก";
    return (
        <div className="flex flex-row justify-center items-center gap-4 my-6 text-c4 text-x w-full">
            <div className="text-grayc3">
                <ChevronLeftCircle className="w-7 h-7" />
            </div>
            <p className="text-lg font-normal">{title} 1 {from} 1</p>
            <div className="text-grayc3">
                <ChevronRightCircle className="w-7 h-7" />
            </div>
        </div>
    );
};

const ArticleListControlMock = ({ currentPage, totalPage }: Props) => {
    const { hasMouseMoved } = useMouseMovement();
    return hasMouseMoved ? <ArticleListControl currentPage={currentPage} totalPage={totalPage} /> : <LoadingComponent />;
};

export default ArticleListControlMock;
